module.exports = {
  language: {
    name: 'English',
    current: 'Current Language',
  },
  common: {
    uploadExImg:'Upload Exhibition Pics',
    uploadExVideo:'Upload Exhibition VID',

    sendImg: 'Send pictures',
    tip: 'Tip',
    submit: 'Submit',
    submit1: '111',
    required1: 'Fields marked with asterisk',
    required2: 'are mandatory',
    importantremind: 'Important Reminder',
    explain: 'Remarks',
    suggest1: 'Please ',
    suggest2: 'sumbit the information on or before',
    suggest3: 'Products with more information will enjoy a higher explosure.',
    placeholder: 'Please input',
    select: 'Please select',
    forshow: 'For Exhibitor Cover Page',
    uploadimg1: 'Format：{format}; Recommended size：{recomsize}px; Size：{filesize}内',
    uploadimg2: 'Suggested File Size：{recomsize}pixels',
    uploadimg3: 'Maximum 6 files. The First Uploaded picture will be used as Cover Picture',
    uploadfile: 'Size: Below 20MB, Maximum 6 Files',
    uploadvideo: 'Format：{format}; Size：Below{filesize}，Please upload one file only. Repeated upload will replace the existing file',
    uploadvideo2: 'Format：{format}; Size：Below{filesize}，Please upload one file only',
    tishi: 'Deadline:{time}',
    selectfile: 'Select Document',
    inputarea1: 'You can enter',
    inputarea2: ' characters from here,Maximum{Num}characters（including punctuation marks and space）',
    tinymce1: 'word count:You can also type',
    tinymce2: 'A character，A maximum of 20 characters can be entered',
    tinymce3: 'haracters (including punctuation and space)  ',
    sort: '*The default sequence is 0, the larger the sequence number, the higher in the ranking',
    operate: 'Apply',
    preview: 'Preview',
    edit: 'Edit',
    delete: 'Delete',
    save: 'Save',
    add: 'Add',
    pagination: 'Total{totalNum}data',
    Number: 'Serial Number',
    order: 'Sort',
    publish: 'Publish',
    status: 'Status',
    statusall: 'All',
    auditstatus: 'Approved | Declined | Under Approval',
    auditstatus2: 'Under Approval | Approved | Declined',
    auditoptions: 'Under Approval | Approved | Declined',
    saveAudit: 'Information saved. Please submit for approval once ready.',
    startdate: 'From',
    enddate: 'End',
    num: {
      one: '1',
      two: '2',
      three: '3',
      four: '4',
      five: '5',
      six: '6',
      seven: '7',
      eight: '8',
      nine: '9',
      ten: '10',
      eleven: '11',
      twelve: '12',
      thirteen: '13',
      fourteen: '14',
    },
    tips:'Tips: only h.264 encoded videos can be uploaded. Please pay attention to the export settings during transcoding and check whether they can be played normally after uploading。',
    reEdit: 'ReEdit',
    share: 'Share',
    imgView: 'Photos Tours',
    videoView: 'Video Tours',
    uploadImg: 'Upload exhibition photos',
    uploadVideo: 'Upload exhibition video',
    received: 'Received Cards',
    invite: 'We sincerely invite you to visit',
    scan: 'Scan QR code for audience pre registration',
    visit: 'You can enter the exhibition site with your ID card',
 
  },
  //登录页面
  logo: {
    title: '25 – 28 October 2023 | New China International Exhibition Center (NCIEC) Beijing, P.R. China',
    denglu: 'Welcome',
    quit: 'back homepage',
    biaoti: 'Exhibitor Center',
    placeholder: 'Username',
    placeholder1: 'Password',
    tiaokuan1: 'I have read and agreed',
    tiaokuan2: 'to the Exhibitor Center  System User Note and Disclaimer',
    submit: 'Login',
    noAccount: 'Don’t have an account?',
    canzhan: 'Register as an exhibitor',
    tiaokuan3: ' The username and password are provided by the organizer and if you have any questions please email to info@together-expo.com，',
    mianze: {
      mianzeTitle: 'Exhibitor Platform - Notice and Disclaimer for System User ',
      mianzeContent:
        '本网站承诺保护您的个人隐私。您无需提供任何个人信息就可以访问我们站点的大多数网页。不过,有时候,我们的确需要某些信息才能为您提供您请求的服务,本隐私权声明解释了这些情况下的数据收集和使用情况。本隐私权声明仅适用于本网站。',
      account: 'Notice & Disclaimer for System User ',
      mianze1:
        'System users should ensure that the information uploaded in this system (including company introductions, etc.) is true and valid, and the relevant promotional content should comply with relevant laws and regulations (including but not limited to advertising laws, anti-unfair competition laws, etc.).',
      mianze2:
        'System users should ensure that the data provided to China Coal Consultant International and Together Expo Limited are true and valid. China Coal Consultant International and Together Expo Limited can transfer the data / information to third parties in order to provide the content for the System Services. And the data provided by system users may be processed and used for their commercial purposes but the foregoing use is subject to the relevant laws of data protection. The user of the system acknowledges and undertakes that the source of the relevant data  provided by China Coal Consultant International and Together Expo Limited is lawful, and that their use of such data has obtained the authorized consent from the data source.',
      mianze3:
        'ystem users should ensure that the material uploaded (including text, logos, images, etc.) does not infringe any third party’s intellectual property rights and other legal rights, including, but not limited to, trademark rights, copyrights, patents and portrait rights',
      mianze4:
        'If system users have violated of the above, China Coal Consultant International  and Together Expo Limited shall have the right to modify, delete the relevant content or stop providing services to the exhibitor, the system users shall bear full responsibility for the violation and compensate China Coal consultant International and Together expo Limited for all losses caused by this (including but not limited to compensation, fines, etc.) to third parties.',
      mianze6: 'disclaimer',
      mianze7: 'System users should ensure that the data provided to China Coal Consultant International and Together Expo Limited are true and valid.',
      mianze8:
        'China Coal Consultant International and Together Expo Limited can transfer the data / information to third parties in order to provide the content for the System Services.',
      mianze9:
        'And the data provided by system users may be processed and used for their commercial purposes but the foregoing use is subject to the relevant laws of data protection.',
      mianze10:
        'The user of the system acknowledges and undertakes that the source of the relevant data  provided by China Coal Consultant International and Together Expo Limited is lawful, and that their use of such data has obtained the authorized consent from the data source.',
      mianze11:
        'System users should ensure that the material uploaded (including text, logos, images, etc.) does not infringe any third party’s intellectual property rights and other legal rights, including, but not limited to, trademark rights, copyrights, patents and portrait rights.',
    },

    dialglog: {
      diaglogMess: 'Login failed. please confirm the terms and conditions.!',
      logSuccess: 'Congratulations! Login Successful!',
      logceil: 'Username or password error, login failed!',
      notNull: 'The user name or password cannot be empty!',
      rules1: 'Please enter username',
      rules2: 'Please enter password',
    },
  },
  //侧边导航
  navbar: {
    hall: 'E-Show',
    home: 'Home',
    exhibitor: 'Exhibitor Information',
    product: 'Product Center',
    active: 'Exhibitor Activities',
    live: 'ExhibitorLiveBoardcast',
    news: 'Exhibitor News',
    publicize: 'Promotional Materials',
    message: 'MY Message',
    service: 'Exhibitor Services ',
    specal: 'Special Design Application',
    lintel: 'Shell Scheme Fascia Name',
    catalogue: 'Show Directory',
    green: 'Furniture/Plants',
    card: 'Exhibitor Badge',
    invite: 'Visitor Invitation',
    wx: 'Wechat Invitation',
    padfInite: 'PDF Invitation',
    email: 'Email Invitation',
    group: 'Group Invitation',
    download: 'Download Center',
    connection: 'Contact us',
    password: 'Reset Password',
    surelogout: 'Are you sure you want to log out?',
    sure: 'Confirm',
    cancel: 'Cancel',
    logout: 'Logout',
  },

  //首页
  homepage: {
    viewall: 'View all',
    exhibitor: 'Exhibitor Information',
    editexhibitor: 'Edit',
    pavilion: 'Hall',
    positionNumber: 'Booth No.',
    boothType: 'Booth Type',
    boothArea: 'Booth Area',
    statistics: 'Statistics',
    completeness: 'Information Completeness',
    productnum: 'The number of products released',
    activenum: 'Live events have been published',
    livenum: 'Live events have been uploaded',
    audiencenum: 'Appointment with visitors',
    product: 'Product Center',
    addproduct: 'Add Products',
    nonproduct: 'You have not added any products and no product information is available at this time',
    news: 'Exhibitor News',
    addnews: 'Add News',
    nonnews: 'No News found.',
    active: 'Exhibitor activities',
    addactive: 'Add activities',
    nonactive: 'No added activities yet.',
    live: 'Exhibitor Live Boardcast',
    addlive: 'Add Live',
    live_suggest: '展商直播发布预告经组委会审核通过后，将在展会官方网站进行发布，将有利于扩大直播影响范围。',
    nonlive: "You haven't added a live boardcast yet, and no Live Boardcast found. ",
    message: 'My Message',
    addmessage: 'Consulting the exhibitors',
    nonmessage: 'No Information found',
  },
  //展商信息
  exhiInformat: {
    exhibitor: 'Exhibitor information',
    companytab: 'Company information',
    boothtab: 'Booth information',
    remind1:
      'All Materials submitted here will be used for your online promotion, and the information will also be used in the promotion of the show official WeChat account and official website of the exhibition, excluding the show directory . If the exhibitor does not make a special statement, the exhibition organizer has the right to use the text, photos, videos, corporate logo and other information submitted by the exhibitor through this platform for the promotion of the China Coal & Mining Expo 2023. The completeness and accuracy of the submitted information will help the exhibitor to rise online attention, enhance pre-show publicity and enjoy better exhibition impact and online business opportunities. The company, product and other related promotional content uploaded or filled in must be in compliance with relevant laws and regulations included but not limited to the Advertising Law and avoid inappropriate expressions.',
    date: '30 August, 2023.',
    cnname: 'Company name - Chinese',
    enname: 'Company name - English',
    type: 'Company Type',
    connection: 'Please contact the organizer by email via info@together-expo.com',
    address: 'Company Address：',
    postCode: 'Postcode：',
    telephone: 'Company Tel. No.：',
    url: 'Company Website：',
    cnlogo: 'Company Logo · Chinese：',
    enlogo: 'Company Logo · English：',
    cnintroduction: 'About the Company - Chinese：',
    enintroduction: 'About the Company  - English：',
    videoCover: 'Company promotional video cover：',
    uploadvideocn: 'Upload video - Chinese：',
    uploadvideoen: 'Upload video - English：',
    uploadwx: 'Upload the company WeChat QR code：',
    pavilion: 'Hall No',
    positionNumber: 'Booth No.',
    boothType: 'Booth Type',
    boothArea: 'Booth Area',
    boothheight: 'Booth Construction Height',
    boothimg: 'Floor Plan',
    bootheffect: 'Booth Design Image',
    affiliatedExhib: 'Exhibits Zone',
  },
  //产品中心
  product: {
    Number: 'serial number',
    productimg: 'Product Picture',
    nameCn: 'Chinese Product Name',
    nameEn: 'English Product Name',
    classification: 'Product Classification',
    series: 'Product Series',
    addproduct: 'Add New Products',
    editproduct: 'Edit the Product',
    date: 'August 30, 2023',
    type: 'Product Model',
    class: 'Product Type',
    Keywords: 'product keywords',
    first: 'Level 1 classification',
    second: 'Level 2 classification',
    third: 'Level 3 classification',
    customclass: 'Product customization series',
    maintain: 'Maintain the product series',
    remarks:
      "Remarks: Click the 'Delete' button and the exhibits under the series will not be deleted, but the series will no longer be displayed on the Product Center page.",
    warnInfo: 'You may select the uploaded products and rank the sequence of the product list. ',
    customclassname: 'Product Series ',
    customplaceholder: 'Please enter the content',
    viewcustom: 'View the Sample',
    remarks2: 'Exhibitors would customize their product series or category names, and customize the product categories.',
    picture: 'Exhbits Picture',
    data: 'Upload Product Information',
    cnintroduce: 'About the Exhibits - Chinese',
    enintroduce: 'About the Exhibits - English',
    cnparameter: 'Exhibits Technical Data - Chinese',
    enparameter: 'Exhibits Technical Data - English ',
    videocover: 'Exhibits Promotion Video Cover',
    video: 'Upload Product Video',

    //维护产品系列内容
    allProduct: 'All Products',
    chengtao: 'Complete Sets of Equipment',
    shusong: 'Conveying Equipment',
    zhihu: 'Supports Equipment',
    caimei: 'Coal Mining Equipment',
    juemiao: 'Anchoring equipment',
    quanzid: 'Fully Automatic Coal Plough',
    zuanji: 'Motor',
    dianji: 'Motor',
    categroy: 'Underground Mining',
    categroy1: 'Underground Tunneling',
    categroy2: 'Coal Mine Electromechanical and Power',
    productName: 'EBH300A Rock Boring Machine',
    procuctName1: 'High-Power Heavy Duty Scraper conveyor',
    productName2: 'Thin Coal Seam Support',
    productName3: 'Alternating current traction shearer',
    productName4: 'TK-3 Geological drilling rig',

    rules: {
      message1: 'Exhibit Picture - Field cannot be blank',
      message2: 'About the Exhibits (Chinese) - Field cannot be blank!',
      message3: 'About the Exhibits (English) - Field cannot be blank',
      message4: 'About the Exhibits (English) - Exceed character limit',
      message5: 'Exhibits Technical Data (Chinese) - Exceed character limit',
      message6: 'Exhibits Technical Data (English) - Exceed character limit',

      tishi1: 'Product Name - Field cannot be blank',
      tishi2: 'Product custom category - field  cannot be blank',
      tishi3: 'The product type cannot be empty',
      tishi4: 'Please select Exhibit Picture',

      tishi5: 'Product Information Document, Below 20MB',

      tishi6: 'Please upload valid video format',
      tishi9: 'Video should not exceed 100MB',
      tishi7: 'Upload File Format:: jpg, png, gif!',
      tishi8: 'Upload File  should not exceed 2MB!',
      tishi10: 'Please check the data!',
      tishi11: 'Edit Product Information Failed. Please edit again!',
      tishi12: 'Add Product Failed. Please add again!',
    },
  },
  //展商活动
  active: {
    activecover: 'Activity Cover Picture',
    name: 'Theme of Activity',
    type: 'Category of Activity',
    location: 'Venue',
    tips: 'Please contact the organizer for any changes of the activity information via +852 2881 5889',
    editactive: 'Edit Activity',
    tishi: 'Deadline:',
    date: '20 October 2023',
    activeType: 'Type of Activity',
    technology: 'Technical Seminar',
    productLanuch: 'New Product Launch ',
    boothActiv: 'Booth Activitiy',
    other: 'Others',
    cnActiveName: 'Activity Theme - Chinese',
    enActiveName: 'Activiity Theme - English ',
    placeholder: 'Please enter Activity Theme ',
    placeholder1: 'Please enter activity location ',
    selectDate: 'Please select the date',
    activeAddress: 'Activitiy Location ',
    activePhote: 'Activity pictures',
    activeIntroCh: 'Please input activity summary - Chinese',
    activeIntroEn: 'Please input activity summary - English',
    noPass: 'Request Declined. Please input the information again. ',
    cause: 'Declined Reason',
    inreview: 'Under Approval',
    approve: 'Approved',
    hint: 'Submit Successfully ',
    submit: 'Submit',
  },
  //展商直播
  live: {
    Livecover: 'Live Boardcast Cover Picture',
    liveName: 'Live Boardcast Title',
    liveType: 'Type of Boardcast',
    liveEdit: 'Edit Live Boardcast',
    liveDate: '20 October 2023',
    tishi: 'Invitation Deadline',

    liveNameCh: 'Live Boardcast Title - Chinese',
    placeholder: 'Please enter live boardcast title. ',
    liveNameEn: 'Live Boardcast Title - English',
    uploadimg1: 'Please Upload Live Boardcast Cover Picture',
    vedioType: 'Type of Video',
    uploadvideo: 'Upload Video',
    liveLink: 'Live Boardcast link',
    liveQcrod: 'Live Boardcast QR Code',
    placeholder1: 'Please unput live boardcast address',
    liveIntroCh: 'Live Boardcast Teaser (Chinese)',
    liveIntroEn: 'Live Boardcast Teaser (English)',
    liveRules: {
      tishi1: 'Start Time - Field cannot be blank',
      tishi2: 'Live introduction · Chinese cannot be empty!',
      tishi3: 'Live cover cannot be empty',
      tishi4: 'Video content cannot be empty',
      tishi5: 'The video address cannot be empty',
      tishi6: 'The qr code picture cannot be blank',
      tishi7: 'Please enter live boardcast link (begin with http or https://)',
      tishi8: 'Please enter live name · Chinese',
      tishi9: 'Please select a start time',
      tishi10: 'Video Type - Field cannot be blank',
      tishi11: 'Please enter live introduction · Chinese',
      tishi12: 'Please select video cover',
    },
  },
  //展商新闻
  news: {
    coverPhoto: 'Cover Picture',
    newsTitle: 'Live Boardcast Title',
    abstract: 'News Summary',
    issueDate: 'Release Date',
    editNews: 'Edit News',
    newsNameCh: 'News Headline - Chinese',
    placeholder1: 'Please enter news headline',
    zhaoyai: 'News Summary (Chinese)',
    newsContent: 'News Content (Chinese) ',
  },
  //宣传资料
  publicity: {
    tishi: 'Upload maximum 6 documents ',
    tishi2: 'File size: within 100M',
    uploadData: 'Upload Document',
    dataName: 'Document Name',
    language: 'Language',
    size: 'File Size',
    editDate: 'Edit Information',
    chinese: 'Chinese',
    English: 'English ',
    dataUsername: 'Promotion Information Title',
    placeholder: 'Please input promotion information title',
    information: 'Document Name',
    clickUpload: 'Click on the upload',
  },
  //我的消息
  minMessage: {
    addresser: 'Sender',
    company: 'Company',
    department: 'Department / Position',
    sendTime: 'Delivery Time',
    look: 'View',
    send: 'Send',
  },

  //特装申请
  special: {
    specialApply: 'Special Design Application',
    exhiName: 'Exhibitor name',
    linkman: 'Contact Person',
    iphone: 'Mobile No.',
    telephone: 'Tel. No.',
    placeholder: 'Please choose type of booth',
    //搭建商信息
    exhibProduc: 'Booth Contractor Information',
    exProName: 'Contractor Name',
    exProAddress: 'Contractor Address',
    exprolinman: 'Contact Person',
    exproIphone: 'Mobile No.',
    exproTelephone: 'Tel. No.',

    //展台信息
    boothInfor: 'Booth Information ',
    boothHeight: 'Booth Height',
    boothtier: 'How many Storey does your booth have',
    onetier: 'Single Storey booth',
    twitier: 'Double Storey booth',
    boothPoint: 'Hanging Point from Hall Ceiling',

    //展台照明用电
    boothIllum: 'Power for Lighting',
    number: 'Sequence No.',
    serviceProject: 'Item',
    quantity: 'Quantity',
    placeholderNum: 'Please enter the quantity',
    locate: 'Point',
    booth: {
      project1: '15A/220V',
      project2: '20A/220V',
      project3: '30A/220V',
      project4: '40A/220V',
      project5: '50A/220V',
      project6: '60A/220V',
      project7: '80A/220V',
      project8: '100A/220V',
      project9: '120A/220V',
    },

    //展台用水
    boothWater: 'Booth Water Supply',
    bootWaterProj: '15A/220V',
    //展台动力用电
    boothPower: 'Machine Power',
    powerProject: {
      project1: 'Temporary Power for Construction 15A/220V',
      project2: 'Temporary Power for Construction 30A/380V',
      project3: '15A/220V/24hr (Single Phase)',
      project4: '30A/380V/24hr（Three Phase)',
      project5: '15A/220V（单相）',
      project6: '30A/380V（Three Phase）',
      project7: '60A/380V（Three Phase）',
      project8: '100A/380V（Three Phase）',
      project9: '150A/380V（Three Phase）',
      project10: '200A/380V（Three Phase）',
      project11: '300A/380V（Three Phase）',
      project12: '400A/380V（Three Phase）',
    },

    uploadimg1: 'Upload Booth Design Image',
    uploadimg2: 'Upload Booth Floor Plan',
    uploadimg3: 'Upload Elevation Plan',

    tishi1: 'Booth Design Image - Field cannot be blank Upload Booth Design Image!',
    tishi2: 'Booth Floor Plan - Field cannot be blank Upload Booth Floor Plan!',
    tishi3: 'Booth Elevation Plan - Field cannot be blank',
    //表单校验提示信息
    rules: {
      exhProName: 'Please enter Activity Theme ',
      comAddress: 'Booth Contractor Address - Field cannot be blank',
      linkman: 'The contact cannot be empty',
      cellphone: 'Mobiel No. - Field cannot be blank',
      cellphone2: 'Mobile No. should not be less than 11 digits',
      email: 'Email Address - Field cannot be blank',
      email2: 'Please enter valid email address',
    },
    //图片校验
    rulesBooth: {
      tishi0: 'Please input booth height',
      tishi1: 'Please select booth design image',
      tishi2: 'Please select booth floor plan',
      tishi3: 'Please select elevation plan',
    },
  },
  //标准门楣
  lintel: {
    explain1: '1、The fascia information is only applicable to the exhibitors of the standard booth;',
    explain2: '2、Only one exhibitor name can be displayed on each standard booth;',
    explain3:
      '3、The fascia information must be consistent with the name of the exhibitor used in the contract, and the exhibitor must ensure that the name provided is correct. ',
    living: 'Fascia Sample',
    companyName: 'Company Name',
    uniteNameCh: 'Company Name - Chinese',
    uniteNameEn: 'Company Name - English',
    rulesMessage: 'Company - Field cannot be blank',
    placeholder1: 'First letter of a word in uppercase, and the rest of the letters in lowercase',
    tishi: 'Please contact the organizer via info@together-expo.com',
    iphone: '010-84293556',
  },

  //会刊信息
  catalogue: {
    explain1: '1、Exhibits information will be included in show directory. Please be concise.',
    explain2: '2、The submitted information should be focus on technical data of the equipment instead of the product brand promotion.',
    explain3: 'If exhibitor interests in post more information on the show directory, please consider to place advertisement or company logo',
    explain4:
      '4、The Exhibits information in the show directory should be provided by exhibitor. Exhibitor should ensure the accuracy and completeness of the content.',
    explain5: '5、Organizer cannot guarantee the publication of late submitted information in the show directory.',
    explain6: '6、Shall the directory content need to be amended, please contact the organizer via info@together-expo.com',
    companyTishi: 'Company Name - Field cannot be blank. ',
    placeholder: 'Please input Company Name (English)',
    placeholder1: 'Please input company address (Chinese)',
    placeholder2: 'Please input company address (English)',
    placeholder3: 'Please enter postcode',
    placeholder4: 'Please enter company telephone no.',
    placeholder5: 'Please enter company email address',
    placeholder6: 'Pelase enter company website',
    companyAddress: 'Company Address (Chinese)',
    companyAddressEn: 'Company Address (English)',
    open: 'Show More',
    down: 'Show Less',
    telephone: 'Tel. No.',
    address: 'Website',
    hint: 'Word count: Can also be entered',
    hint2: 'character,Maximum input{number}character(Contains punctuation and Spaces)',
    exhibClass: 'Exhibits Classification',
    hint3: 'Pleae select the type of exhibits. In case of non- specified exhibits, please provide more details.',
    other: 'Other Product Categories',
    time: '31 August 2023',
    modifi: 'save',
    rules: {
      emial: 'Invalid email address, please input again.',
      email_null: 'Email Address - Field cannot be blank',
      companyNameC: 'Company Name (Chinese) - Field cannot be blank',
      column14: 'Company Name (English ) - Field cannot be blank',
      column15: 'Company Address (Chinese) - Field cannot be blank',
      column16: 'Company Address (English ) - Field cannot be blank',
      telephone: 'Tel. No. - Field cannot be blank',
      introduceC: 'Exhibits Information (Chinese) - Field cannot be blank',
      introduceE: 'Exhibits Information (English) - Field cannot be blank',
    },
  },
  //家具绿植租赁
  Furniture: {
    exhi: 'Furniture Rental',
    gennRent: 'Green Plant Rental',
    title: 'Rental of Furniture and Green Plant',
    date: 'Deadline for Application : 20 October 2023',
    shuoming: 'Description:',
    smContent: 'The furniture and green plant rental of this exhibition is provided by XXXX, detailed service information please refer to the below',
    iphone: 'Service Number',
    xianchang: 'Onsite Contact During Exhibition',
    zhanguan: 'Hall W - 010 80468229',
    tele: 'Mobile : 13691586795、13811600271、13552931289',
    jiandu: 'Supervision Service Phone : 010-80468237 / 80468249',
    email: 'Mailbox sfcs@ciec.com.cn',
    serviceTime: 'Service Hour',
    buzhan: 'Booth Construction Period: 0900 - 1700',
    buzhanEnd: 'Last Date of Booth Construction : 0900 - 2100',
    startKai: 'Exhibition Period : 0900 - 1700',
    serviceAddre: 'Service Point',
    bangong: 'W1-W2/E1-E2 Loading Area Rental Office',
    bangong2: 'W3-W4/E3-E4 Loading Area Rental Office',
    bangong3: 'Additional Rental Service Point Depending on the size of the Exhibition ',
    bangong4: 'Free Distribution, Maintenance, Pick Up, Invoicing',
    selectNumb: '选择租用展位：',
    titleRent: 'Total Rental Cost',
    Furint: {
      select: '',
      // piece of Furniture
      zhuijia: '- Piece of Furniture',
      picture: 'Photo',
      serial: 'Serial Number',
      special: 'Model',
      number: 'Quantity',
      mine: 'My Rental Furniture',
      exhiName: 'Exhibits Name',
      zero: 'Zero rent',
      rentNum: 'Rental Quantity',
      exhinumb: 'Booth Number',
      states: 'Condition',
      title: 'Please Confirm the list of Furniture Rental ',
      count: 'Sub Total',
      operate: 'Operation',
      desk: 'Table',
      chair: 'Chair',
      eletrirc: 'Electrical Appliances',
      other: 'Others',
      sofa: 'Sofa',
      biaotan: 'Standard Material',
      setMea: 'Set',
      tea: 'Tea Table',
      dialglog: '请选择则租用展位',
      dialglog1: '提交失败请选择租赁得展具',
    },
    //展具绿植
    GeenPlat: {
      plant: 'Plant',
      lvzhi: '- Pot of Plant',
      lvzhi1: '',
      title: 'My Rental Plant',
      pinghua: 'Vase',
      hua2: 'Flower',
    },
  },

  //参展商证
  card: {
    explain: '1.	If exhibitor need more badges, please contact the organizer via',
    explaincnnect: '王涛 010-84293538 Email:chinaminexpo@vip.163.com',
    explain1:
      '2.	Under the Epidemic Prevention and Control guideline, all participants enter the exhibition fairground should be pre-registered with real name on identity document and scan the original document to enter the exhibition hall.',
    explain3: ' 3.	All information collected will only be used for enter the venue for China Coal & Mining Expo 2023. ',
    allocation: 'Guideline of Free Badges distruction',
    standard: 'the standard booth',
    showDard: 'Standard Booth',
    remark: 'Remarks',
    area: '{area}㎡',
    num: '{num}个',
    shuoming1: '4 badges for each 24sqm (1 badge for each additional 6sqm) ',
    shuoming2: 'Maximum of 80 badges',
    shuoming3: 'Each booth should not exceed 80 bages. Exceeding the prescribed number, Extra badges will cost RMB20 each.',
    shuoming4: 'Order onsite will cost RMB40 per badge.',
    contestant: 'Exhbitor Personnel',
    addContestant: 'Add new badge ',
    name: 'Name',
    cardType: 'ID Type',
    idcard: 'ID ',
    unitName: 'Company Name',
    unitAddress: 'Company Address',
    IDnumber: 'ID No.',

    duty: 'Department',
    iphone: 'Mobile No.',
    email: 'Email',
    state: 'Status',
    pass: 'Approved',
    noPass: 'Declined',
    under: 'Under Approval',
    tishi1: 'If you have numbers of badges to be submited, please ',
    tishi2: 'Please download the exhibitor badge application templete',
    uploadFile: 'Upload',
    tishi3: 'Please select the individual and submit',
    addContest: 'Add New Exhibitor Badge',
    editContest: 'Edit Exhibitor Badge',

    placeholder: 'Please enter the name',
    placeholder1: 'Please enter the company name',

    placeholder2: 'Please input Type of ID document',
    placeholder3: 'Please input ID Document No.',
    placeholder4: 'Please select booth number ',
    placeholder5: 'Please input booth number',
    placeholder6: 'Please enter Position ',
    placeholder7: 'Please enter mobile no.',
    placeholder8: 'Please enter Company Address',
    placeholder9: 'Please enter email',

    tishi4: 'Exhibitor badge application is closed.',
    tishi5: 'If you need to update of exhibitors, please contact the organizer via info@together-expo.com',
    tishi6: 'additional order badges.',
    tishi7: 'Please contact the organziervia info@together-expo.com',
    tele: '010-84293556',

    rules: {
      name: 'Name - field cannot be blank',
      company: 'Company Name - field cannot be blank',
      address: 'Company Address - field cannot be blank',
      column11: 'ID Document Number - Field cannot be blank',
      column12: 'ID No. - field cannot be blank',
      phone: 'Mobile No. - field cannot be blank',
      phoneLength: 'Mobile No Format is not correct.',
      papersType: 'Please select ID Document Type',
      idcard: 'ID Number is not valid, please input again',
      placeholder: 'Please select ID Document Type first',
      bootNum: 'Booth number cannot be empty',
      email: 'Invalid email address, please input again. ',
      emailRequire: 'Email - field cannot be blank',
    },
  },

  //下载中心
  downdCenter: {
    uploadTime: 'Upload Time',
    downd: 'Download',
  },

  //联系我们
  connection: {
    committee: 'Organizer',
    name: 'China Coal Consultant International',
    address: 'RM.501, B88 Andingmenwai Dajie,Dongcheng District, Beijing',
    principal: 'Hall Manager',
    // 第二行
    th2: 'E1、E2、E5',
    th2name: 'Mr. Wang Yingpeng',
    th2iphone: '18600660197',
    thTelep: '010-84293556',
    //第三行
    th3name: 'Ms. Ma Jie',
    th3iphone: '18600660196',
    th3Telep: '010-84293555',

    //第四行
    th4: 'E3、E4',
    th4name: 'Ms. Shi Wei',
    th4iphone: '18600660198',
    th4Telep: '010-84293557',

    //第五行
    th5name: 'Mr. Wang Zichen',
    th5iphone: '16601369081',
    th5Telep: '010-64212207',

    //第六行
    th6: 'W1',
    th6name: 'Ms. Yin Xiaofei (ZOE)',
    th6iphone: '17310285580',
    th6Telep: '010-84510286',

    //第七行
    th7: 'W2',
    th7name: 'Mr. Wang Tao',
    th7iphone: '18600660178',
    th7Telep: '010-84293538',

    //第八行
    th8: 'W3、W4',
    th8name: 'Mr. Yang Li',
    th8iphone: '13911007430',
    th8Telep: '010-84293559',
    //第九行
    th9name: 'Mr. He Zichen',
    th9iphone: '18600623265',
    th9Telep: '010-84293624',

    conference: 'Conference Contacts:',
    connePerson: 'ZhaoAiDong　010-84293552　18600660195',
    principal1: 'Exhibition In-Charge:',
    princiPers1: 'Mr. Zhang Lin　010-84293530　15801077723',
    princiPers2: 'Ms. Mu Xiao Ping　010-84293551　13501179983',

    //海外扩招
    haiwai: {
      haiwaititle: 'Overseas exhibition',
      overseasName: 'Organizer',
      companyName: 'Together Expo Limited',
      hongkAddree: 'Hong Kong Head Office',
      address: 'Room A, 16/F Eastern Commercial Centre,83 Nam On Street, Shau Kei WanHong Kong',
      telePerson: 'Contact Person',
      connPerson: 'Ms. Katherine Lee　00852-28815889',
      connPerson2: 'Ms. Zoe Yin　010-84510286　17310285580',
      beijingAddress: 'Beijing Office',
      bjAddress: 'Room 12A11, Building A, Kunsha Center No. 16, Xinyuanli, Chao Yang District,Beijing 100027 , P.R.China',
    },

    //主场服务商
    zhuchang: {
      homeName: 'Official Technical Service Provider',
      compayName: 'Beijing M.H.TALE Expo Co., Ltd. ',
      address: 'Address',
      Address: 'No.362, 4/F, Hall 1, No.6, north Road of China International Exhibition Center, Chaoyang District, Beijing',
      iphone: 'Tel. No.',
      iphoneNum: '010-84602355 / 2358 / 2388 / 2369 / 2396',
      //第一行
      extensionNum: 'Ext. No.',
      telementNum: 'Mobile No',
      email: 'Email',

      //第二行
      th2: 'E1-E5',
      th2Name: 'Zhu Boyan',
      th2exten: '8004',
      th2iphone: '18612850217',
      //第三行
      th3Name: 'Fu Shuang',
      th3exten: '8002',
      th3iphone: '13718373237',

      //第四行
      th4: 'W1-W4',
      th4Name: 'Yang Peng',
      th4exten: '8010',
      th4iphone: '13261251998',

      //第五行
      th5Name: 'Zhang Kaixian',
      th5exten: '8008',
      th5iphone: '15210833245',
    },

    //设备吊装服务商
    diaozhuang: {
      dzName: 'Official Crane & Hoisting Services Provider',
      //  companyLabel:'单位名称',
      companyName: 'China International Exhibition Transportation Co., Ltd.',
      companyAddress: 'Rm 539, Hall No. 1, CIEC,  No. 6 Beisanhuan Road, Chaoyang District, Beijing',
      telephone: 'Tel No.',

      //第二行
      th: 'E1-E5',
      thName: 'Dong Hui',
      thTelet: '010-84600605',
      thIphone: '13651049167',

      //第三行
      th3: 'W1-W4',
      th3Name: 'Bai Peng',
      th3Telet: '010-84600605',
      th3Iphone: '13910015451',
    },

    //酒店接待服务商
    hotel: {
      hotelTitle: 'Hotel Accommodation',
      companyName: 'Times International Conference &Exhibition Co., Ltd',
      connectPer: 'Wang Xiang Yun　18612291377 (mobile & wechat)',
    },
  },

  //修改密码
  editPassword: {
    passwordTitle: 'Reset Password',
    originPassword: 'Existing Password',
    newPassword: 'New Password',
    confimPassword: 'Confirm New Password',
    placeholder: 'Password',
    placeholder1: 'The two passwords are inconsistent. ',
  },
  //团体时间
  teamInvite: {
    teamTitle: 'Group Invitation',
    tishi1:
      'In order to e provide a safe environment for the participants, the organizer will strictly implement the relevant provisions of the "Requirements for the Joint Prevention and Control Mechanism of the State Council" and the "Guidelines for the Prevention and Control of COVID-19 for the Beijing Convention and Exhibition Industry".',
    tishi2:
      'For all exhibitors/visitors, preregistration with real-name authentication" process will be adopted, and participants need to present their original ID / Passport to enter the venue.',
    placeholder1: 'Please enter Name / Company Name',
    search: 'Search',
    addbuys: 'New Added Buyer',
    departement: 'Department / Position',
    companyName: 'Company',
    companyAddress: 'Company Address',
    editbuy: 'Edit Buyer Information',
    inforTishi: 'Request Failed.',
    inforTishi2: 'Please submit again.',
    inforTishi3: 'Information Submitted Successfully',
    inforTishi4: ' Group Invitation has been submit for organizer approval, please check the status accordingly.;',
    idcart: 'ID',
    certificate: 'Military ID',
    passport: 'Passport ',
    hk: 'Hong Kong and Macau Home Return Permit',
  },
  //微信邀请函
  wxInvite: {
    wx: 'Wechat Invitation',
    wxTitle: 'Wechat Invitation',
    enInvite: 'Chinese Invitation',
    comapanych: 'Company Logo',
    canguan: 'For Enquries',
    imgTishi: 'Format: jpg, png, suggested size: 600*240 pixels. Size: Below 2MB',
    uploadimg: 'Please upload picture',
    tishiIphone: 'Please input enqurieis tel. no. ',
    uploadLogo: 'Upload logo',
    booth: 'Both No.：',
  },
  //pdf邀请
  pdfInvite: {
    padfTitle: 'PDF invitation letter',
    tishi1: 'China’s 19th International Technology Exchange',
    tishi2: 'Equipment Exhibition on Coal & Mining',
    tishi3: 'Please Download PDF file to join and visit the  China’s 19th',
    tishi4: 'International Technology Exchange & Equipment Exhibition on Coal & Mining',
    downd: 'Click to Download',
  },

  //邮件邀请
  emailInvite: {
    title: 'Venue: New China International Exhibition Center (NCIEC), Beijing',
    time: 'Date: 25-28 October 2023',
    invite: 'Welcome to visit',
    exName: 'China Coal & Mining Expo 2023',
    address1: 'New China International Exhibition Center(NEIEC) Beijing, China',
    client: 'Dear Customer:',
    content: 'Our company will exhibit in the China Coal & Mining Expo 2023 in Beijing on 26-29  October 26-29.',
    content2:
      'We will display new products, new technologies and new solutions at the exhibition. As our partner and important customer, we sincerely invite you to visit us at the booth.',
    timeLabel: 'Date:',
    addressLabel: 'Venue:',
    line: 'Pre-register as our visitor now. ',
    aboutme: 'About us',
    weProduct: 'Our Products ',
    weActive: 'Our Activity',
    content3:
      'will be held at the New China International Exhibition Center (NCIEC) in Beijing on 26-29 October, 2023.With the theme of " A Showcase of Smart & Low Emission Driven Coal Industry", this exhibition attracted nearly 800 exhibitors from 13 countries and regions around the world, with the largest exhibition area ever of nearly 110,000 square meters. Major domestic and overseas coal mining machinery and equipment companies participated in the exhibition. Many exhibitors will bring their products, new equipment and new technologies developed in the past two years. Intelligent themed exhibits and overseas brand exhibitors will continue to attract visitor’s attention. This is bound to be another gluttonous feast for coal industry fellow. The show also brings together an online exhibition- the E-show Coal Machinery Network. This exhibition is expected to attract 120,000 visitors from more than 30 countries and regions around the world.',
    content4: "A Shouldn't Miss Event of the Coal Industry. We are looking forward to see you in the show. ",
    exhibitorList: 'Exhibitor List',
    exhibits: 'Exhibits List',
    graph: 'Floor Plans',
    live: 'Live Boardcast ',
    under: 'More about the exhibition ',
    exhitZixun: 'Exhibitor Enquries',
    person: ' Wang Zichen',
    inputEmail: 'Please enter visitor emai',
    inviteTa: 'invite them to join the event.',
    content5: 'Please enter email account for each visitor. Maximum 200 visitor invitations.',
  },

  //footer
  footer: {
    title: 'Organizing Committee of China Coal & Mining Expo 2023',
    linke: 'Quick Link',
    tishi1: 'WeChat Official Account',
    tishi2: 'Please Scan the QR code to Follow Us ',
    // 展会官网添加内容
    titleTop: 'Nineteenth session',
    titleBottom: 'Organizing Committee of China Coal & Mining Expo 2023',
    link: 'Quick Link',
    company: '汇显展览有限公司',
    weChatOfficialAccount: 'WeChat Official Account',
    qrCodeAttention: 'Please Scan the QR code to Follow Us ',
    mobileQrCodeAttention: 'Please scan the two-dimensional code, and pay attention to the WeChat official account.',
    copyright: 'Copyright : China Coal Consultant International',
    technicalSupport: 'Technical Support：China coal information technology co. LTD BEIJING',
    spareNumber1: '京公网安备11010102002548号',
    spareNumber2: '京ICP备09033595号-1',
    address: 'Zhongmei Building 605, Andingmenwai Street Yi 88, Dongcheng District, Beijing',
    linkUrl: {
      viewcz: 'I want to exhibit',
      viewcg: 'I want to Visit',
      zwt: 'Floor Plan',
      zhrc: 'Exhibition Schedule ',
      hzZhanhui: 'Official Website',
      mjlt: 'Forum',
    },
    unit: {
      title1: 'Host ',
      title2: 'Co-Host',
      title3: 'Organizers',
      text1: 'China National Coal Association',
      text2: 'China National Coal Group Corp',
      text3: 'China Coal Consultant International',
    },
    //结束

    linkeText: {
      linkeText1: 'I want to exhibit',
      linkeText2: 'I want to Visit',
      linkeText3: 'Floor Plan',
      linkeText4: 'Exhibition Schedule ',
      linkeText5: 'Official Website',
      linkeText6: 'Forum',
    },
  },

  dialog: {
    //展商信息页面公司信息的内容
    message: 'Company Logo - Chinese information cannot be blank!',
    message1: 'File Format: jpg, png!',
    message2: 'File Size: Below 10MB!',
    message3: 'Please upload an image file!',
    message4: 'Upload File Format: mpf, mov!',
    message5: 'File Size: Below 100MB!',
    confirm: 'Replace the previous uploaded video? ',
    sureMess: 'Confirm Information',
    sure: 'sure',
    cancel: 'cancel',

    confirmDelete: 'Confirm to delete? ',
    attention: 'Attention!',
    deletSucce: 'Successfully deleted!',
    suncSort: 'Successfully rearrange the sequence！',
    cancelDelet: 'Delete Cancelled',

    confirmSubmit: 'Confirm to Submit?',
    submitSuccess: 'Sucessfully Submitted',

    //添加活动的弹框信息
    startTime: 'Start Time- Field cannot be blank!',
    endTime: 'End Time - Field cannot be blank!',
    actiPict: 'Activitiy Photo cannot be blank!',
    actTextEn: 'Activity Summary (Chinese) - Field cannot be !',
    tishi1: 'Please select type of activity',
    tishi2: 'Please input activity title (Chinese)',
    tishi3: 'Start Time- Field cannot be blank',
    tishi4: 'End Time - Field cannot be blank',
    tishi5: 'Please enter activity location ',
    tishi6: 'Please select activity pictures',
    tishi7: 'Please input activity summary - Chinese',
    message6: 'Cover Photo: Below 500KB',
    message7: 'File Size : Beow 2MB',
    undeed: 'Approved',
    nounder: 'Request Decline',
    undering: 'Under Approval',

    //添加新闻

    message8: 'Please enter news headline',
    message9: 'Please enter Sumarry - Chinese',
    message10: 'Please enter News Content - Chinese',
    message11: 'News Content (Chinese) - Field cannot be blank!',

    //上传宣传资料
    message12: 'Document - Field cannot be empty!',
    message13: 'Language - Field cannot be empty',
    message14: 'Title - Field cannot be empty',
    message15: 'Document - Field cannot be empty',

    //会刊信息
    message16: 'Submit Directory Information Successfully!',
    message17: 'Directory Information Submission Failed!',
    message18: 'Please complete the compulsory information !',

    //参展商证
    message19: 'Successfully Uploaded the  Exhibitor Personnel Information in excel list!',
    message20: 'Please amend the red highlight part and submit again.',
    message21: 'Exhibitor Personnel Information has been submitted successfully',
    message22: 'Invalid ID No. Please input again!',
    message23: 'Edit Exhibitor Personnel Information Successfully!',
    message24: 'Delete Exhibitor Personnel Information Successfully!',
    message25: 'Add New Personnel Successfully!',
    message26: 'Fail to add New Exhibitor Personnel',

    //团队邀请
    message27: 'Upload Buyer Excel List Successfully!',
    addbuy: 'Add New Buyer Successfully',
    bugceil: 'Fail to add New Buyer',
    editbug: 'Edit Buyer Information Successfully',
    deletbug: 'Delete Buyer Information Successfully',
    message28: 'No Information submitted.',
    submit: 'Submit',
  },
  share: {
    friend: 'Share with friends',
    wechat: 'Share to wechat',
    link: 'Copy link',
  },
  downloadMobile: {
    isDownload: 'Do you want to download',
    download: 'Download',
  },
};
